import type { FC } from 'react';

export const ApplicationOverviewTab: FC = () => (
  <div className='flex-1 bg-default' />
);
